export default {
  title: '{{plan}} ist aktiv',
  plan: 'Plan: {{plan}}',
  free_until: 'Kostenlos bis {{date}}',
  continue: 'Weiter',
};
